import React, { Component } from "react";
import Loading from "./Loading";
import PropTypes from "prop-types";
import InputRow from "./InputRow";

export default class Citizenship extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      selectedCountry: "",
      cityOfBirth: this.props.cityOfBirth || "",
      selectedNationality: "",
      selectedOtherNationality: "",
    };
  }

  componentDidMount() {
    this.setState({
      loading: false,
      selectedCountry: this.props.countryOfBirth || "",
      selectedNationality: this.props.nationality || "",
      selectedOtherNationality: this.props.otherNationality || "",
      cityOfBirth: this.props.cityOfBirth || "",
    });
    let dateOfBirth = "";
    if (this.props.dateOfBirth) {
      const date = new Date(this.props.dateOfBirth);
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let year = date.getFullYear();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      if (year < 10) year = "000" + year;
      else if (year < 100) year = "00" + year;
      else if (year < 1000) year = "0" + year;
      dateOfBirth = `${year}-${month}-${day}`;
    }
    this.setState({ dateOfBirth });
  }

  render() {
    const validationError = this.props.error;
    const {
      loading,
      error,
      selectedNationality,
      selectedCountry,
      selectedOtherNationality,
      cityOfBirth,
    } = this.state;

    if (loading) return <Loading />;

    return (
      <div id="height">
        <div>
          <p style={{ color: "black" }}>
            Click next to navigate to the next section
          </p>
          {error && <p style={{ color: "red" }}>{error}</p>}

          <InputRow
            name="select"
            rowName="Nationality"
            required="*"
            errMsg={validationError.selectedNationality || ""}
            data={this.props.countryData}
            value={selectedNationality}
            onChange={(val) => {
              this.setState({ selectedNationality: val });
              this.props.collectState("CIT", {
                selectedCountry: selectedCountry,
                cityOfBirth: cityOfBirth,
                selectedNationality: val,
                selectedOtherNationality: selectedOtherNationality,
              });
            }}
          />

          <InputRow
            name="select"
            rowName="Country Of Birth"
            required="*"
            errMsg={validationError.selectedCountry || ""}
            data={this.props.countryData}
            value={selectedCountry}
            onChange={(val) => {
              this.setState({ selectedCountry: val });
              this.props.collectState("CIT", {
                selectedCountry: val,
                cityOfBirth: cityOfBirth,
                selectedNationality: selectedNationality,
                selectedOtherNationality: selectedOtherNationality,
              });
            }}
          />

          <InputRow
            name="text"
            rowName="City Of Birth"
            required="*"
            errMsg={validationError.cityOfBirth || ""}
            value={cityOfBirth}
            onChange={(val) => {
              this.setState({ cityOfBirth: val });
              this.props.collectState("CIT", {
                selectedCountry: selectedCountry,
                cityOfBirth: val,
                selectedNationality: selectedNationality,
                selectedOtherNationality: selectedOtherNationality,
              });
            }}
          />

          <InputRow
            name="select"
            rowName="Other Nationality"
            required=""
            errMsg={validationError.selectedOtherNationality || ""}
            data={this.props.countryData}
            value={selectedOtherNationality}
            onChange={(val) => {
              this.setState({ selectedOtherNationality: val });
              this.props.collectState("CIT", {
                selectedCountry: selectedCountry,
                cityOfBirth: cityOfBirth,
                selectedNationality: selectedNationality,
                selectedOtherNationality: val,
              });
            }}
          />
        </div>

        <button className="save" onClick={this.props.onSave}>
          Next
        </button>
      </div>
    );
  }
}

Citizenship.propTypes = {
  onSave: PropTypes.func.isRequired,
  countryData: PropTypes.array.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  countryOfBirth: PropTypes.number,
  nationality: PropTypes.number,
  cityOfBirth: PropTypes.string,
  otherNationality: PropTypes.number,
  collectState: PropTypes.func,
  error: PropTypes.object,
};
